import clsx from "clsx";
import React from "react";
import { ErrorMessageProps } from "./FormFields.interfaces";
import styles from "./FormFields.module.scss";

const ErrorMessage: React.FC<ErrorMessageProps> = ({
  id,
  message,
  hasError,
  isActive,
}) => {
  if (!hasError) return null;

  return (
    <div className={styles["message-wrapper"]} id={id}>
      <p className={clsx(styles.message, isActive && styles.active)}>
        {isActive && <span className="sr-only">Error:</span>}
        {message}
      </p>
    </div>
  );
};

export default ErrorMessage;
